import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=37b5bea0&"
import script from "./Announcement.vue?vue&type=script&lang=ts&"
export * from "./Announcement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports